import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-text-confirm',
  templateUrl: './text-confirm.component.html',
  styleUrls: ['./text-confirm.component.scss']
})
export class TextConfirmComponent implements OnInit {

  constructor(private modal: NzModalRef) { }
  text!: string;
  showError!: boolean;
  placeholder!: string;
  textHtmlModal!: any;

  ngOnInit(): void {
    //
  }

  setShowError(): void {
    this.showError = true;
  }

  close(): void {
    this.modal.close();
  }

}
